import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User ,SpiderAccount} from '../../../_models';
import { AuthenticationService, NotificationService, SpiderService, UserService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './spider-account-list.component.html' })
export class SpiderAcountListComponent implements OnInit {
  filterForm: FormGroup;
  newAccountForm: FormGroup;
  accountList: SpiderAccount[];
  currentUser: User;
  loading = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;

  filterable = {
    name: '',
  };

  sourceList = {"JP6969":5, "PAY365":7};

  constructor(private fb: FormBuilder,
    private userSvc: UserService,
    private authSvc: AuthenticationService,
    private spiderSvc: SpiderService,
    private notification: NotificationService,
    private modalService: NgbModal) {

    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.loadPage(1);
  }

  openModal(targetModal) {
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newAccountForm = this.fb.group({
      source: [null, Validators.required],
      name: [null, Validators.required],
      label: [''],
      partnerId: [''],
      apiKey: [''],
    });
  }

  get f() { return this.newAccountForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  onSubmit() {
    this.processing = true;
    var newDataParam = this.newAccountForm.getRawValue();
    if (this.newAccountForm.valid) {

      if (confirm("Are you sure to add the account now?")) {
        this.spiderSvc.addAccount(newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Account added successfully!", "New Account");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add account, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  deleteAccount(account) {
    if (confirm("Are you sure to delete this account?")) {
      this.spiderSvc.deleteAccount(account.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Account deleted successfully!", "Delete Account");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting account, please try again later.", "Error");
        }
      })
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.accountList = [];
    let params = this.formParam(page);

    // get page of items from api
    this.spiderSvc.listAccounts(params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.accountList = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record for this admin.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      name: this.filterable.name,
    }
    return params;
  }

}
